module.exports = __webpack_public_path__ + "img/OBUHomePage_05.78381abf.png";